<template>
  <div ref="newsTop">
    <h2 class="section-title m-4 text-center text-lg px-5 py-3">お知らせ</h2>
    <div v-if="notice.length > 0">
      <ul class="border-b border-section_border">
        <li v-for="message in notice" :key="message.id" class="course border-b">
          <div @click="getDetail(message)" class="bg-white message-box">
            <div v-if="isUnread(message)" class="float-left bg-yellow-300 px-1 mt-1 mr-2 text-xs">NEW</div>
            <p class="time">{{ getMoment(message.dispDate) }}</p>
            <p class="title">{{ message.title }}</p>
            <div class="labels"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
  
  <script>
  import { mapGetters } from 'vuex'
  import moment from "moment";
  import Constants from "../constants"
  import { event } from 'vue-gtag'
  
  export default {
    data () {
      return {
        message: {}
      }
    },
    name: 'News',
    mounted() {
      this.$store.dispatch('notice/fetchAll')
    },
    computed: {
      ...mapGetters({
        notice: 'notice/getAll',
        alreadyRead: 'notice/getAlreadyRead'
      })
    },
    methods: {
      getDetail: function (message) {
        this.$store.dispatch('notice/updateAlreadyRead', message.id)
        event('お知らせ',{no:message.id, title:message.title})
        this.$router.push( {name: 'newsdetail', params: { no: message.id } })
      },
      getMoment: function (date) {
        return moment(date).format('YYYY/MM/DD')
      },
      getQuestionnaire: function () {
        window.open(Constants.QUESTIONNAIRE_URL)
      },
      isUnread: function (message) {
        return !this.alreadyRead.includes(message.id)
      }
    }
  }
  </script>

<style lang="scss" scoped>
.time {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  color: #75828d;
  grid-gap: 12px;
  gap: 12px;
}

.title{
  display: block;
  font-size: 16px;
  font-style: normal;
  line-height: 130%;
  color: #313234;
}

.message-box{
  display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    grid-gap: 6px;
    gap: 6px;
}
.labels {
  display: flex;
  grid-gap: 8px;
  gap: 8px;
}
</style>